<ion-app>
  <ion-router-outlet></ion-router-outlet>

  <!-- Development Test Screen Floating Button (hidden on voice-clone stacks so bottoms aren’t covered) -->
  @if (isDevelopment && showDevTestFab) {
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
      <ion-fab-button size="small" color="warning" routerLink="/test/streak-pools">
        <ion-icon name="flask"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  }
</ion-app>
